import * as React from 'react';
import { push as Menu } from 'react-burger-menu';
import NavMenu from '../components/NavMenu';
import { inject, observer } from 'mobx-react';
import { Icon } from 'semantic-ui-react';
import './Layout.scss';

interface LayoutState {
    opened: boolean;
}

@inject('commonStore')
@observer
class Layout extends React.Component<any, LayoutState> {

    constructor(props: any) {
        super(props);
        const closeMenu = props.commonStore.closeMenu.bind(props.commonStore);
        window.onkeydown = (ev) => {
            let e = (ev || window.event) as KeyboardEvent;
        
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeMenu();
            }
        };
  
    }

    public render() {
        const closeMenu = this.props.commonStore.closeMenu.bind(this.props.commonStore);
        const undefinedMenuProps = {
            disableOverlayClick: () => closeMenu(),
            disableCloseOnEsc: true
        } as any;

        return (
            <div id="layout-wrap">
                <div className="menu-wrap">
                    <div id="menu-wrap">
                        <Menu
                            isOpen={this.props.commonStore.menuOpened}
                            burgerButtonClassName="burger-button"
                            crossButtonClassName="nav-close"
                            pageWrapId="page-wrap"
                            outerContainerId="layout-wrap"
                            {...undefinedMenuProps}
                        >
                            <NavMenu />
                        </Menu>
                    </div>
                </div>

                <div id="page-wrap" className="page-class">
                    <button 
                        className="burger-button invisible-button" 
                        onClick={() => this.props.commonStore.openMenu()}
                    >
                        <Icon
                            circular 
                            color="teal" 
                            size="big"
                            name="bars"
                        />
                    </button>
                    {this.props.children}
                </div>;
            </div>
        );
    }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/container/Layout.tsx